import React from 'react';
import { HomeIcon } from 'lucide-react';
interface LogoProps {
  variant?: 'dark' | 'light';
}
export function Logo({
  variant = 'dark'
}: LogoProps) {
  const text = variant === 'dark' ? 'text-navy-900' : 'text-white';
  const sub = variant === 'dark' ? 'text-navy-900/55' : 'text-white/65';
  return <a href="#top" className="group flex items-center gap-2.5" aria-label="JV Home Service — home" data-id="element-185" data-mp="3v7wc1cr9hj66">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-navy-900 text-white" data-id="element-186" data-mp="msl14l5hfy9p">
        <HomeIcon className="h-5 w-5" strokeWidth={2.2} aria-hidden="true" data-id="element-187" data-mp="rqw9ssk1k2qc" />
      </span>
      <span className="flex flex-col leading-none" data-id="element-188" data-mp="dsxvfn5q06au">
        <span className={`font-display text-[17px] font-extrabold tracking-tight ${text}`} data-id="element-189" data-mp="duir5g3rtvaa">
          JV Home Service
        </span>
        <span className={`mt-1 text-[10px] font-semibold uppercase tracking-[0.16em] ${sub}`} data-id="element-190" data-mp="2yhvoti6jjaqz">
          Northwest Houston, TX
        </span>
      </span>
    </a>;
}